import React, { PureComponent } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutableProptypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import Modal from 'react-modal'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import { BACKEND_URL } from '_config/environment'

import UserTable from './components/UserTable'
import LogWithinTable from './components/LogWithinTable'
import UserDetail from './components/UserDetail'
import AddUserForm from './components/AddUserForm'
import ManageCodes from './components/ManageCodes'
import AddCodeForm from './components/AddCodeForm'
import styles from './styles.css'

const mapStateToProps = ({ user }) => ({
  user,
})

const mapDispatchToProps = {}

class Admin extends PureComponent {
  static propTypes = {
    user: ImmutableProptypes.map,
  }

  static defaultProps = {
    user: new Map(),
  }

  state = {
    userList: [],
    logsWithinList: [],
    codeList: [],
    currentDetailId: null,
    editUserInfo: {},
    modalIsOpen: false,
    showUserDetail: false,
    showAddUserForm: false,
    showAddCodeForm: false,
    error: '',
  }

  componentDidMount() {
    Modal.setAppElement('body')
    this.getState(this.props)
  }

  getState = props => {
    if (props.user.get('isAdmin', false)) {
      Promise.all([
        fetch(`${BACKEND_URL || 'http://localhost:3000'}/admin/userList`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${props.user.get('token')}`,
          },
        }).then(res => res.json()),
        fetch(`${BACKEND_URL || 'http://localhost:3000'}/admin/userLogsWithinList`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${props.user.get('token')}`,
          },
        }).then(res => res.json()),
        fetch(`${BACKEND_URL || 'http://localhost:3000'}/admin/promotionalCode`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${props.user.get('token')}`,
          },
        }).then(res => res.json()),
      ])
        .then(([userList, logsWithinList, codeList]) => {
          this.setState({
            userList,
            logsWithinList,
            codeList,
          })
        })
        .catch(err => console.error(err))
    }
  }

  onAddUserClick = () => {
    this.setState({ showAddUserForm: true, modalIsOpen: true })
  }

  onEditUserClick = user => {
    this.setState({
      editUserInfo: user,
      showAddUserForm: true,
      showUserDetail: false,
      modalIsOpen: true,
    })
  }

  onAddCodeClick = e => {
    e.preventDefault()
    this.setState({ showAddCodeForm: true, modalIsOpen: true })
  }

  onRowClick = id => {
    this.setState({ currentDetailId: id, showUserDetail: true, modalIsOpen: true })
  }

  onConfirmModal = body => {
    const { currentDetailId, showAddUserForm, showAddCodeForm } = this.state

    if (showAddCodeForm) {
      fetch(`${BACKEND_URL || 'http://localhost:3000'}/admin/promotionalCode`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.props.user.get('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      })
        .then(res => {
          if (res.ok) {
            this.getState(this.props)
            this.onCloseModal()
          } else {
            this.setState({ error: res.statusText })
          }
        })
        .catch(err => console.error(err))
    } else if (showAddUserForm) {
      // if creating or editing
      if (currentDetailId === null) {
        fetch(`${BACKEND_URL || 'http://localhost:3000'}/admin/createAccount`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${this.props.user.get('token')}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        })
          .then(res => {
            if (res.ok) {
              this.getState(this.props)
              this.onCloseModal()
            } else {
              this.setState({ error: res.statusText })
            }
          })
          .catch(err => console.error(err))
      } else {
        fetch(`${BACKEND_URL || 'http://localhost:3000'}/admin/updateAccount`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${this.props.user.get('token')}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        })
          .then(res => {
            if (res.ok) {
              this.getState(this.props)
              this.onCloseModal()
            } else {
              this.setState({ error: res.statusText })
            }
          })
          .catch(err => console.error(err))
      }
    }
  }

  onCloseModal = () => {
    this.setState({
      currentDetailId: null,
      modalIsOpen: false,
      showAddUserForm: false,
      showUserDetail: false,
      showAddCodeForm: false,
      editUserInfo: {},
      error: '',
    })
  }

  render() {
    const {
      currentDetailId,
      userList,
      logsWithinList,
      codeList,
      modalIsOpen,
      showUserDetail,
      showAddUserForm,
      showAddCodeForm,
      editUserInfo,
      error,
    } = this.state

    return (
      <div className={classnames(styles.main)}>
        <Tabs className={classnames(styles.Grid, styles['Grid--alignCenter'], styles.main)}>
          <TabList className={classnames(styles['Grid-cell'], styles.tabList)}>
            <Tab
              className={classnames(styles.tab, styles.title)}
              disabledClassName={classnames(styles.tabDisabled)}
              selectedClassName={classnames(styles.tabSelected)}
            >
              Accounts
            </Tab>
            <Tab
              className={classnames(styles.tab, styles.title)}
              disabledClassName={classnames(styles.tabDisabled)}
              selectedClassName={classnames(styles.tabSelected)}
            >
              Logs Within
            </Tab>
            <Tab
              className={classnames(styles.tab, styles.title)}
              disabledClassName={classnames(styles.tabDisabled)}
              selectedClassName={classnames(styles.tabSelected)}
            >
              Manage Codes
            </Tab>
          </TabList>

          <TabPanel>
            <button
              onClick={this.onAddUserClick}
              className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
            >
              ADD USER
            </button>
            <UserTable userList={userList} onRowClick={this.onRowClick} />
          </TabPanel>
          <TabPanel>
            <LogWithinTable logsWithinList={logsWithinList} />
          </TabPanel>
          <TabPanel>
            <button
              onClick={this.onAddCodeClick}
              className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
            >
              ADD CODE
            </button>
            <ManageCodes codeList={codeList} />
          </TabPanel>
        </Tabs>

        <Modal
          className={classnames(styles.modal)}
          overlayClassName={classnames(styles.overlay)}
          isOpen={modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.onCloseModal}
          bodyOpenClassName={classnames(styles['disable-body-scroll'])}
          contentLabel="adminModal"
        >
          {showUserDetail && <UserDetail id={currentDetailId} onEditClick={this.onEditUserClick} />}
          {showAddUserForm && (
            <AddUserForm
              editUserInfo={editUserInfo}
              onConfirm={this.onConfirmModal}
              onCancel={this.onCloseModal}
            />
          )}
          {showAddCodeForm && (
            <AddCodeForm onConfirm={this.onConfirmModal} onCancel={this.onCloseModal} />
          )}
          <div className={classnames(styles.error)}>{error}</div>
        </Modal>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Admin)



// WEBPACK FOOTER //
// ./src/views/admin/index.js